import React, { Component } from 'react';
import { Form, Icon, Input, Button, Modal } from 'antd';
import LoginStore from './LoginStore';
import {getAuth, OAuthProvider, onAuthStateChanged, signInWithPopup} from 'firebase/auth';
import {Link,withRouter} from 'react-router-dom';
import {observer} from 'mobx-react';
import GlobalStore from '../../store/GlobalStore';
import WSPhoto from '../Workspace/WorkspaceProfilePicture';
import Axios from 'axios';
const base_url = GlobalStore.getSiteURL();


@observer
class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            isLoggingIn:false,
            isWorkspaceSelected:false,
            workspaceDetails:{},
            tip:''
        }
    }

    componentDidMount(){
        Axios.get(`${GlobalStore.prismic_endpoint}?access_token=${GlobalStore.prismic_access_token}`,'dsds').then(fetchedData=>{
            if(fetchedData.status===200){
                var refid =fetchedData.data.refs[0].ref;
                Axios.get(`${GlobalStore.prismic_endpoint}/documents/search?access_token=${GlobalStore.prismic_access_token}&ref=${refid}&q=[[:d=at(document.type,"tip_of_the_day")]]`)
                .then(res=>{
                    if(res.status===200){
                       let tips = res.data.results;
                       var tip = tips[Math.floor(Math.random()*tips.length)];
                       this.setState({tip:tip}); 
                    }
                }).catch(err=>{
            
                })
            }
        })

        var self = this;
        GlobalStore.setTitle('Login');
        var subdomain = window.location.href.split('//')[1].split('.')[0];
        const auth = getAuth();
        onAuthStateChanged(auth,function(user) {
            if (user) {
                return self.props.history.push('/authentication'); 
            }
            else{
                if(subdomain === 'app'){
                    self.setState({isWorkspaceSelected:false});
                }
                else{
                    self.setState({isWorkspaceSelected:true});
                    LoginStore.checkWorkspaceExistance(subdomain).then(res=>{
                        if(res.data.status){
                            self.setState({workspaceDetails:res.data.data})
                        }
                        else{
                            self.setState({workspaceDetails:{}})
                        }
                        
                    })
                }
            }
        });
        
        this.initRecaptcha();

    }

    initRecaptcha = () =>{
        // window.grecaptcha.ready(function() {
        //     window.grecaptcha.execute('6Lc3MbEUAAAAAPJdVJnOBfGJxXdEWbl_pLRMONLq', {action: 'login'}).then(function(token) {
        //        console.log(token)
        //     });
        // });
    }


    chooseWorkspacelater = () =>{
        window.location.href = base_url+'/login';
    }

    handleCancel = () =>{
        LoginStore.wrongWorkspaceModalVisible = false;
    }
    
    
 
    Login = (event) =>{
        event.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({isLoggingIn:true});
                LoginStore.handleLoginSubmit(values,event).then(res=>
                    {
                        if(res.status!==200)
                        {
                            this.setState({isLoggingIn:false});
                        }
                    }).catch(error=>{
                        this.setState({isLoggingIn:false});
                    })
        }
        else{
            this.setState({isLoggingIn:false});
        }
        })
    }

    
    deSelectWorkspace = () =>{
        window.location.href = `${GlobalStore.getSiteURL()}/login`;
    }

    getBaseUrl(){
        let loginLink = GlobalStore.getSiteURL()
        return loginLink;
    }

    onSigninWithProvider = provider => {
        switch (provider) {
            case 'microsoft':
                const provider = new OAuthProvider('microsoft.com');
                provider.setCustomParameters({
                    prompt: 'consent',
                    login_hint: 'user@firstadd.onmicrosoft.com'
                });

                const auth = getAuth();
                signInWithPopup(auth, provider).then((result) => {
                    // const credential = OAuthProvider.credentialFromResult(result);
                    // const accessToken = credential.accessToken;
                    // console.log("accessToken",accessToken);
                }).catch((error) => {
                });
                break;
        
            default:
                break;
        }
    }



    render() {
        const { getFieldDecorator } = this.props.form;
        return <React.Fragment>
            <div className="form-h login-page">
                <div className="lt-block">
                    <div className="logo-img"><Link to=""><img alt='GoodFlow' src="/images/logo_v3(1).svg" height="30" /></Link></div>
                    <div className="login-block">
                   
                        <div className="login-sec">
                            <div className="lg_form">
                                
                                {/* <div className="logo-h"><img src="/images/logo.svg" height="30" /></div> */}
                                
                                {/* <Form.Item>
                                <a className="google-oauth" onClick={()=>LoginStore.signInWithGoogle().then(res=>{if(res.status===200){this.props.history.push('home')}})}><span><img src="images/google-icon.svg" alt=""/></span>Log in with Google</a>
                                </Form.Item> */}
                                {/* <span className="or">or</span> */}
                                <span className="login-heading">Log in to your workspace</span>
                                <div className="workspace-block login-workspace">
                            
                                    {
                                        this.state.isWorkspaceSelected && Object.keys(this.state.workspaceDetails).length > 0?
                                        <div className="box">
                                        <div className="list-block">
                                            <div className="lt-block">
                                                <div className="fetures">
                                                    <WSPhoto image={this.state.workspaceDetails.profile_image !== undefined?this.state.workspaceDetails.profile_image:''} id={this.state.workspaceDetails._id} imageWidth="100%" imageHeight="100%" name={this.state.workspaceDetails.name} fontSize="24px"></WSPhoto>
                                                </div>
                                                <div className="text-block">
                                                    <h3>{this.state.workspaceDetails.name}</h3>
                                                    <span>{this.state.workspaceDetails.userName}.goodflow.io</span>
                                                </div>
                                            </div>
                                            <div className="close_btn">
                                                <Button className="btn" onClick={()=>this.deSelectWorkspace()}><Icon type="close" /></Button>
                                            </div>
                                        </div>
                                        </div>:
                                        <Link to="/workspace/choose"><div className="box choose-box">
                                        <div className="list-block">
                                            <div className="lt-block">
                                                <div className="fetures"><Icon type="plus" /></div>
                                                <div className="text-block">
                                                    <h3>Choose Workspace</h3>
                                                    <span>You can also choose workspace after Login</span>
                                                </div>
                                            </div>
                                            </div>
                                        </div></Link>
                                    }
                                </div>
                                <Form onSubmit={(event) =>this.Login(event)} className="login-form">
                                    <Form.Item>
                                        <label for="userName">E-mail</label>
                                        {getFieldDecorator('userName', {
                                            rules: [{ required: true, message: 'Please input your E-mail!' }],
                                        })(
                                            
                                            <Input type="text" autoFocus/>
                                        )}
                                    </Form.Item>
                                    <Form.Item>
                                    <label for="password">Password</label>
                                        {getFieldDecorator('password', {
                                            rules: [{ required: true, message: 'Please input your Password!' }],
                                        })(
                                            <Input type="password"/>
                                        )}
                                    </Form.Item>
                                    {/* <Form.Item>
                                        <a href={`${this.getBaseUrl()}/password/help`} className="login-form-forgot">Forgot password?</a>
                                    </Form.Item> */}
                                    <Form.Item>
                                
                                    {/* <a href={`${this.getBaseUrl()}/password/help`} className="login-form-forgot">Forgot password?</a> */}
                                        
                                    <Button type="primary" disabled={this.state.isLoggingIn} htmlType="submit" className="common-btn login-form-button">
                                        {
                                            this.state.isLoggingIn?'Please wait...':'Log in'
                                        }
                                    </Button>
                                    
                                    {/* <div className="or-box">
                                        <span>Or</span>
                                    </div>

                                    <Button type="primary" className="common-btn login-form-button btn-wth">
                                        <span className="icon-img"><img src="images/google-icon.svg" alt=""/></span>
                                        Login with Google
                                    </Button>
                                    <Button type="primary" className="common-btn login-form-button btn-wth" onClick={()=>this.onSigninWithProvider('microsoft')}>
                                        <span className="icon-img"><img src="images/microsoft-logo.svg.png" alt=""/></span>
                                        Login with Microsoft
                                    </Button> */}

                                    </Form.Item>
                                    <Form.Item>
                                        <div className="signup-sec">
                                            <span>Don't have an account?</span>
                                            <a href={`${this.getBaseUrl()}/signup`}>Sign up</a>
                                        </div>
                                        <div className="forgot-sec">
                                            <a href={`${this.getBaseUrl()}/password/help`} className="login-form-forgot">Forgot password?</a>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="rt-block" style={{background:'#B3AA98'}}>
                    <div className="desc">
                        <h2>Tip of the day</h2>
                        <p>{tip && tip.data && tip.data.tooltip_text[0].text}</p>
                    </div>
                </div> */}
                {/* <h6><Link to="create-account">Create an account if you don't have one</Link></h6> */}
       
            </div>

            <Modal className="workspace-modal"
                title="Wrong Workspace!"
                visible={LoginStore.wrongWorkspaceModalVisible}
                onOk={()=>this.chooseWorkspacelater()}
                onCancel={()=>this.handleCancel()}
                okText='Choose Workspace Later'
                >
                    <p>Sorry! You are not part of this workspace. Can you please recheck the workspace you are trying to logging in. Additionally, you can choose workspace after logging in. Please click on Choose workspace later button to login without specifying any workspace</p>
                    
            </Modal>
        </React.Fragment>
    }
}


const WrappedNormalLoginForm = Form.create()(Login);
export default withRouter(WrappedNormalLoginForm);